@if (pager.total > 0 && !loadingContent) {
  <div class="kanban-column rounded border">
    @if (column.type === "status") {
      <div class="kanban-header {{ column.colorClass }} text-white">
        <div class="d-flex align-items-center justify-content-between">
          <i class="{{ column.icon }} me-2 font-24"></i>
          <span class="fw-semibold">
            {{ column.label | translate }}
          </span>
        </div>
        <span
          class="px-2 py-1 d-flex align-items-center justify-content-center bg-white text-dark fw-bold rounded"
        >
          {{ pager.total }}
        </span>
      </div>
    } @else if (column.type === "department") {
      <div class="kanban-header bg-primary text-white">
        <div class="d-flex align-items-center">
          <i class="{{ column.icon }} me-2 font-24"></i>
          <span class="fw-semibold">
            {{ column.label | translate }}
            @if (!channelFilter) {
              <small class="badge font-11 opacity-75">
                {{ getChannelNameFromItems(pager.list) | truncate: 15 }}
              </small>
            }
          </span>
        </div>
        <span
          class="px-2 py-1 d-flex align-items-center justify-content-center bg-white text-dark fw-bold rounded"
        >
          {{ pager.total }}
        </span>
      </div>
    } @else {
      <div class="kanban-header kanban-header-user">
        <div class="d-flex align-items-center">
          <div class="avatar-xs me-2">
            <span
              class="avatar-title rounded-circle text-primary font-14 p-1 fw-bold bg-primary bg-opacity-10"
            >
              {{ getInitials(column.label | translate) }}
            </span>
          </div>
          <span class="fw-semibold text-dark">{{ column.label | translate }}</span>
        </div>
        <span
          class="px-2 py-1 d-flex align-items-center justify-content-center bg-primary text-white fw-bold rounded"
        >
          {{ pager.total }}
        </span>
      </div>
    }

    <div class="kanban-body scroll">
      @if (pager.total === 0) {
        <div
          class="d-flex flex-column align-items-center justify-content-center h-100"
        >
          <i class="mdi mdi-alert-circle-outline font-36 opacity-50"></i>
          <span class="text-muted font-14">{{ 'attendance.monitoring.noAttendancesFound' | translate }}</span>
        </div>
      }

      @for (item of pager.list; track item._id) {
        <div
          class="kanban-card card mb-1"
          (click)="goToAttendance(item)"
          [ngClass]="{
            'bg-danger bg-opacity-10 border-danger':
              getCustomerWaitingSeconds(item) > delayThresholdSeconds,
          }"
        >
          <div class="card-body p-1">
            <div class="d-flex align-items-start">
              <span class="flex-shrink-0 me-1">
                <img
                  [src]="getContactImage(item.contact)"
                  (error)="onImageError($event)"
                  [alt]="item.contact?.name ?? ('attendance.monitoring.noName' | translate)"
                  class="rounded-circle"
                  height="38"
                />
              </span>

              <div class="w-100 min-width-0">
                <h5 class="mt-0 mb-0 font-14">
                  <span class="float-end d-flex flex-column align-items-end">
                    <p class="text-muted font-11">
                      {{
                        $safeNavigationMigration(item.lastMessage?.updatedAt)
                          | timezoneDate
                            : "DD/MM/YY HH:mm"
                            : getTimezoneCompanyCurrentUser()
                      }}
                    </p>
                    @if (getCustomerWaitingSeconds(item) > 0) {
                      <small
                        class="font-10 text-muted"
                        [matTooltip]="'attendance.monitoring.customerWaitingTime' | translate"
                      >
                        <i class="mdi mdi-timer"></i>
                        {{
                          convertSecondsToTime(getCustomerWaitingSeconds(item))
                        }}
                      </small>
                    }
                  </span>
                  <span
                    class="fw-semibold text-truncate d-block pe-5"
                    matTooltip="{{ item.contact?.name }}"
                  >
                    {{ item.contact?.name || ('attendance.monitoring.noName' | translate) }}
                  </span>
                </h5>

                <p class="mb-0 text-muted font-14">
                  @if (item.lastMessage) {
                    <span class="text-truncate d-block pe-4">
                      {{ (getMessagePreview(item) | translate) | truncate: 20 }}
                    </span>
                  }
                </p>

                <div
                  class="d-flex align-items-center justify-content-between mt-1"
                >
                  <div class="d-flex align-items-center">
                    @if (item.channel?.type) {
                      <img
                        [src]="getChannelIcon(item.channel)"
                        class="me-1"
                        height="14"
                        [alt]="$safeNavigationMigration(item.channel?.name)"
                      />
                    }
                    <small class="fst-italic text-muted">
                      {{
                        item.department?.name
                          ? item.department.name
                          : item.channel?.name
                      }}
                    </small>
                  </div>
                  @if (column.type === "user" || column.type === "department") {
                    <div
                      class="float-end badge font-16"
                      [matTooltip]="getStatusLabel(item.status) | translate"
                      matTooltipPosition="above"
                    >
                      <i
                        class="{{ getStatusIcon(item.status) }}"
                        [ngClass]="{
                          'text-danger': item.status === 'OVERTIME',
                          'text-warning': item.status === 'PENDING',
                          'text-success': item.status === 'IN_PROGRESS',
                          'text-secondary': item.status === 'PAUSED',
                          'text-dark': item.status === 'CLOSED',
                        }"
                      ></i>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (pager.list.length < pager.total) {
        <div class="d-flex justify-content-center py-2">
          <button
            class="btn btn-sm btn-light text-muted"
            (click)="loadPage(pager.page + 1)"
          >
            {{ 'attendance.monitoring.loadMore' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
}
